import { render, staticRenderFns } from "./EnsaiosAliquotasTableSelecao.vue?vue&type=template&id=28d6a746&"
import script from "./EnsaiosAliquotasTableSelecao.vue?vue&type=script&lang=ts&"
export * from "./EnsaiosAliquotasTableSelecao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VSimpleTable,VSwitch})
